<script>
import { mapActions, mapGetters } from 'vuex';
import { Field, Form } from 'vee-validate';
import * as Yup from 'yup';

import VInput from '@/components/Common/VInput';
import VSelect from '@/components/Common/VSelect';
import SvgClose from '@/components/Svg/Close';

const initFormData = () => ({
  name: null,
  phone: null,
  model: null,
  complectation: null,
  kpp: null,
  volume: null,
  power: null,
  fuel: null,
  priceMin: null,
  priceMax: null,
});

const SINGLE_NAME = {
  models: 'model',
  kpp: 'kpp',
  volume: 'volume',
  power: 'power',
  fuel: 'fuel',
};

export default {
  props: {
    defaultParams: {
      type: Object,
      default: () => {},
    },
    brand: {
      type: Object,
      required: true,
    },
    fieldComplectation: {
      type: Boolean,
      default: false,
    }
  },
  components: {
    VInput,
    VSelect,
    SvgClose,
    VeeForm: Form,
    VeeField: Field,
  },
  initFormData,
  SINGLE_NAME,
  data() {
    return {
      form: this.$options.initFormData(),
    };
  },
  setup() {
    const schema = Yup.object().shape({
      name: Yup.string().required(),
      phone: Yup.string().required(),
      model: Yup.mixed().nullable(false).required(),
      complectation: Yup.mixed().nullable(false).required(),
      kpp: Yup.mixed().nullable(false).required(),
      volume: Yup.mixed().nullable(false).required(),
      power: Yup.mixed().nullable(false).required(),
      fuel: Yup.mixed().nullable(false).required(),
      priceMin: Yup.string().required(),
      priceMax: Yup.string().required(),
    });

    const whithoutComplectationSchema = Yup.object().shape({
      name: Yup.string().required(),
      phone: Yup.string().required(),
      model: Yup.mixed().nullable(false).required(),
      kpp: Yup.mixed().nullable(false).required(),
      volume: Yup.mixed().nullable(false).required(),
      power: Yup.mixed().nullable(false).required(),
      fuel: Yup.mixed().nullable(false).required(),
      priceMin: Yup.string().required(),
      priceMax: Yup.string().required(),
    });

    return {
      schema,
      whithoutComplectationSchema,
    };
  },
  watch: {
    'form.model'() {
      if (this.form.model) {
        this.loadComplectations(new URLSearchParams({ brand_id: this.brand.id, model_id: this.form.model?.id }));

        this.form.complectations = null;
      }
    },
  },
  computed: {
    ...mapGetters({
      complectations: 'FormLooking/complectations',
    }),
    formData() {
      const formData = {
        name: this.form.name,
        phone: this.form.phone,
        model: this.form.model?.name,
        complectation: this.form.complectation?.name,
        kpp: this.form.kpp?.name,
        volume: this.form.volume?.name,
        power: this.form.power?.name,
        fuel: this.form.fuel?.name,
        price_min: this.form.priceMin,
        price_max: this.form.priceMax,
        action: 'looking',
      };

      if (this.form.complectation?.name.length > 0) {
        formData.brand = this.brand.name;
      }
      return formData;
    },
  },
  methods: {
    ...mapActions({
      togglePopup: 'Popups/togglePopup',
      loadComplectations: 'FormLooking/loadComplectations',
      send: 'FormData/send',
    }),

    onSubmit(value, actions) {
      this.send(this.formData);

      this.togglePopup('popup-message');

      this.reset();
      setTimeout(() => {
        actions.resetForm();
      }, 1000);
    },
    reset() {
      this.form = this.$options.initFormData();
    },
  },
};
</script>

<template>
  <div>
    <vee-form
      :validation-schema="complectations.length === 0 || !fieldComplectation ? whithoutComplectationSchema : schema"
      novalidate
      class="grid grid-cols-1 xl:grid-cols-2 gap-3.5"
      @submit="onSubmit"
    >
      <vee-field
        v-slot="{ handleChange, errorMessage }"
        name="name"
      >
        <v-input
          v-model="form.name"
          placeholder="Имя*"
          theme="white"
          format="name"
          name="name"
          :error="errorMessage"
          @update:modelValue="handleChange"
        />
      </vee-field>

      <vee-field
        v-slot="{ handleChange, errorMessage }"
        name="phone"
      >
        <v-input
          v-model="form.phone"
          placeholder="+7 (___) ___-__-__"
          theme="white"
          format="phone"
          :error="errorMessage"
          @update:modelValue="handleChange"
        />
      </vee-field>

      <vee-field
        v-slot="{ handleChange, errorMessage }"
        name="model"
      >
        <v-select
          v-model="form.model"
          :options="this.defaultParams.models"
          placeholder="Модель*"
          :error="errorMessage"
          @update:modelValue="handleChange"
        />
      </vee-field>

      <vee-field
        v-if="fieldComplectation"
        v-slot="{ handleChange, errorMessage }"
        name="complectation"
      >
        <v-select
          v-model="form.complectation"
          :options="complectations"
          :disabled="form.model === null || complectations.length === 0"
          placeholder="Комплектация*"
          :error="errorMessage"
          @update:modelValue="handleChange"
        />
      </vee-field>
      <vee-field
        v-slot="{ handleChange, errorMessage }"
        name="kpp"
      >
        <v-select
          v-model="form.kpp"
          :options="this.defaultParams.kpp"
          placeholder="КПП*"
          :error="errorMessage"
          @update:modelValue="handleChange"
        />
      </vee-field>
      <vee-field
        v-slot="{ handleChange, errorMessage }"
        name="volume"
      >
        <v-select
          v-model="form.volume"
          :options="this.defaultParams.volume"
          placeholder="Объем двигателя*"
          :error="errorMessage"
          @update:modelValue="handleChange"
        />
      </vee-field>
      <vee-field
        v-slot="{ handleChange, errorMessage }"
        name="power"
      >
        <v-select
          v-model="form.power"
          :options="this.defaultParams.power"
          placeholder="Мощность*"
          :error="errorMessage"
          @update:modelValue="handleChange"
        />
      </vee-field>
      <vee-field
        v-slot="{ handleChange, errorMessage }"
        name="fuel"
      >
        <v-select
          v-model="form.fuel"
          :options="this.defaultParams.fuel"
          placeholder="Тип топлива*"
          :error="errorMessage"
          @update:modelValue="handleChange"
        />
      </vee-field>

      <div class="grid grid-cols-2 gap-3.5">
        <vee-field
          v-slot="{ handleChange, errorMessage }"
          name="priceMin"
        >
          <v-input
            v-model="form.priceMin"
            placeholder="Цена от, ₽*"
            theme="white"
            prefix="от"
            sufix=" руб."
            format="price"
            :error="errorMessage"
            @update:modelValue="handleChange"
          />
        </vee-field>

        <vee-field
          v-slot="{ handleChange, errorMessage }"
          name="priceMax"
        >
          <v-input
            v-model="form.priceMax"
            placeholder="*"
            theme="white"
            prefix="до"
            sufix=" руб."
            format="price"
            :error="errorMessage"
            @update:modelValue="handleChange"
          />
        </vee-field>
      </div>

      <button
        type="submit"
        class="button button_green button_big w-full"
        :class="{ 'xl:col-start-2': !fieldComplectation }"
      >
        Отправить
      </button>
    </vee-form>
  </div>
</template>

